import { useEffect } from "react";
import { nativeStorageInterface } from "../..";
import { CAMPUS_COLLECTION } from "../../reduxStore/actions/main";

/**
 * Sets the inital settings from either localstorage or native storage
 */
export function useSettings(
  setLanguage,
  setSettingsFromStorage,
  setFavouritesFromStorage,
  setSearchesFromStorage,
  serverDataLoaded,
  currentCampusId
) {
  const initLanguage = () => {
    nativeStorageInterface.get("language").then((r) => {
      const cLang = r;

      const lang = cLang ? cLang : navigator.language.split(/[-_]/)[0];
      if ("de" === lang || "en" === lang || "fr" === lang) {
        setLanguage(lang);
      } else {
        setLanguage("en");
      }
    });
  };
  const getFilters = (settings) => {
    const campusIds = CAMPUS_COLLECTION.getAllCampuses().map((c) => c.id);
    const filter = settings.filter;

    if (!filter) return null;

    if (!campusIds.includes(filter.phonebook.campusId)) {
      filter.phonebook.campusId = campusIds[0];
    }

    if (!campusIds.includes(filter.event.campusId)) {
      filter.event.campusId = campusIds[0];
    }

    if (!campusIds.includes(filter.search.campusId)) {
      filter.search.campusId = campusIds[0];
    }

    return filter;
  };

  const initSettings = () => {
    nativeStorageInterface.get("settings").then((r) => {
      const settings = r ?? {};
      const filter = getFilters(settings);

      setSettingsFromStorage({ ...settings, filter });
    });
  };

  const initPhonebookFavorites = () => {
    nativeStorageInterface.get("phonebook-favourites").then((r) => {
      const favorites = r ?? [];
      setFavouritesFromStorage(favorites);
    });
  };
  const initLastSearches = () => {
    nativeStorageInterface.get("lastSearched").then((r) => {
      const lastUsed = {};
      const lastUsedSaved = r ?? null;

      if (!lastUsedSaved) {
        setSearchesFromStorage();
      } else {
        for (const category in lastUsedSaved) {
          if (lastUsedSaved.hasOwnProperty(category)) {
            lastUsed[category] = lastUsedSaved[category];
          }
        }

        setSearchesFromStorage(lastUsedSaved);
      }
    });
  };

  useEffect(() => {
    if (!serverDataLoaded) return;

    initLanguage();
    initPhonebookFavorites();
    initLastSearches();
  }, [serverDataLoaded]);

  useEffect(() => {
    if (!serverDataLoaded || currentCampusId == null) return;

    initSettings();
  }, [serverDataLoaded, currentCampusId]);
}
